export default __webpack_public_path__ + "static/media/item_1@2x.b9d07b0e.png";